import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { CarState } from './types';

type Variables = {
  id: number;
  reservationId: number;
  type: string;
  action: string;
};
type Response = CarState;

export const useCarSecurityStorage = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id, reservationId, type, action }) =>
    client({
      url: `v2/cars/${id}/security/storage`,
      method: 'POST',
      data: {
        reservation_id: reservationId,
        type,
        action,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
